import { AppDispatch } from 'common/redux/core/store.config';
import { Dispatch, SetStateAction } from 'react';
import {
    VideoTypesArray,
    VideoType,
    selectVideoTypeArray,
    VideoDetailsPayload,
    VideoLinkDTO
} from '../models/configuration.model';
import { appStateActions } from 'common/redux/app-state';
import { DEFAULT_ERROR_MESSAGE, FAILURE_HEADER, MAIN_ROUTES } from 'common/config';
import { Action, MessageType } from 'common/enums';
import { ConfigurationService } from '../redux/configuration.service';
import { ApiResult } from 'common/models';
import { useNavigate } from 'react-router-dom';
import { configurationActions } from '../redux';
export const getFormattedVideoTypes = (data: VideoTypesArray) => {
    if (data?.length > 0) {
        return data.map((ele: VideoType) => {
            return { label: ele.videoTypeName, value: ele.videoTypeId };
        });
    }
    return [];
};

/**
 * This function is a utility function which fetches video types data
 * from api
 * @param {AppDispatch} dispatch - The `dispatch` parameter is a function that is used to dispatch
 * actions to the Redux store. It is typically provided by the `useDispatch` hook from the
 * `react-redux` library.
 * @param setVideoTypes - `setVideoTypes` is a function that takes in a new state value for the
 * `VideoTypesArray` and updates the state with that new value.
 */
export const getVideoTypeData = async (
    dispatch: AppDispatch,
    setVideoTypes: Dispatch<SetStateAction<selectVideoTypeArray>>
) => {
    dispatch({
        type: appStateActions.showLoader.type,
        payload: true
    });
    const rawResp: ApiResult<VideoTypesArray> | undefined =
        await ConfigurationService.getVideoTypes();
    if (rawResp?.errors && rawResp?.hasErrors) {
        dispatch({
            type: appStateActions.showLoader.type,
            payload: false
        });
        /** need to show failed pop up here */
        dispatch({
            type: appStateActions.showMessageModal.type,
            payload: {
                isVisible: true,
                header: FAILURE_HEADER,
                message: DEFAULT_ERROR_MESSAGE,
                type: MessageType.Error
            }
        });
    } else if (rawResp?.value) {
        setVideoTypes(getFormattedVideoTypes(rawResp?.value));
        dispatch({
            type: appStateActions.showLoader.type,
            payload: false
        });
    }
};

export const saveUpdateVideoLinkUtil = (
    data: VideoLinkDTO,
    locationState: { data: VideoLinkDTO; action: Action },
    dispatch: AppDispatch,
    navigate: ReturnType<typeof useNavigate>
) => {
    const navigationCallback = (param: boolean): void => {
        if (param) {
            navigate(MAIN_ROUTES.CONFIGURATION_VIDEO_LINKS);
        }
    };

    if (locationState?.action === Action.Create) {
        const payload: VideoDetailsPayload = {
            accountId: data.accountId,
            status: data.status,
            title: data.title,
            videoId: data.videoId,
            videoTypeId: data.videoTypeId
            // videoDetailId: null
        };
        dispatch(
            configurationActions.saveVideoLink({
                payload: payload,
                callBack: navigationCallback
            })
        );
    } else {
        dispatch(
            configurationActions.updateVideoLink({
                payload: data,
                callBack: navigationCallback
            })
        );
    }
};
